import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: 'fi',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    openGame_button: 'Open game stats',
                    viewStats_button: 'View game stats',
                    playGame_button: 'Play SoMe Detectives',
                    gameId_heading: 'Game name',
                    gameId_help: 'Enter the game name',
                }
            },
            sv: {
                translation: {
                    openGame_button: 'Öppna spelstatistik',
                    viewStats_button: 'Öppna spelstatistik',
                    playGame_button: 'Spela SoMe Detectives',
                    gameId_heading: 'Spel namn',
                    gameId_help: 'Ange spelets namn',
                }
            },
            fi: {
                translation: {
                    openGame_button: 'Avaa pelitilasto',
                    viewStats_button: 'Katso pelitilastoja',
                    playGame_button: 'Pelaa SoMe Detectivesiä',
                    gameId_heading: 'Pelin nimi',
                    gameId_help: 'Syötä pelin nimi',
                }
            }
        }
    });

export default i18n;